import React, { useState } from 'react';
import './MissionsPage.css';

// Import the image
import missions from './missions.jpg';

function MissionsPage() {
  const [showSection1, setShowSection1] = useState(false);
  const [showSection2, setShowSection2] = useState(false);
  const [showSection3, setShowSection3] = useState(false);
  const [showSection4, setShowSection4] = useState(false);
  const [showSection5, setShowSection5] = useState(false);
  const [showSection6, setShowSection6] = useState(false);
  const [showSection7, setShowSection7] = useState(false);
  const [showSection8, setShowSection8] = useState(false);
  const [showSection9, setShowSection9] = useState(false);
  const [showSection10, setShowSection10] = useState(false);
  const [showSection11, setShowSection11] = useState(false);
  const [showSection12, setShowSection12] = useState(false);
  const [showSection13, setShowSection13] = useState(false);
  const [showSection14, setShowSection14] = useState(false);
  const [showSection15, setShowSection15] = useState(false);


  return (
    <div className="missions-container">
      <div className="missions-image-container">
        <img src={missions} alt="Missions" className="missions-image" />
      </div>
      <div className="missions-text">
        <p>
          어떤 만남이든지 만남에는 그 만남에 대한 '기대'가 선행되는 경우가 많습니다. 그 만남과 교제를 
          가능케 하신 십자가의 존귀하신 사랑보다 내가 만나는 사람을 통한 내 인생의 유불리를 따지게 되는 만남이 많습니다. 
          나와 만나며 교제하는 사람들이 내 기대와 꿈에 따라줄 것을 요구하고 그 기대와 꿈이 현실화 
          되지 않을 경우 쉽게 분노하고 좌절하며 만남을 파탄으로 몰고 갑니다. 만남과 교제에 대한 기대와 
          꿈이 성도의 교제를 통해 드러나야 하는 십자가보다 앞서기 때문입니다. 그래서 늘 긴장하고 
          있는 삶, 늘 경계를 해체하지 않는 만남이 심지어 교회 안에서 까지 발생하고 있음이 현실입니다. 
          하지만 플로리다 말씀교회는 다릅니다. 다르고자 하는 교회입니다. 지치고 상한 영혼들이 평안히
          쉴만한 마르지 않는 영혼의 쉼터로 탬파지역 한인들과 함께 하길 기대합니다. 우리와 함께 하지 않으시렵니까? 
          세상에서 누릴수 없는, 세상이 줄 수도 없는 주님의 평안과 안식을 누리게 되실 줄 믿습니다.
        </p>
        <h2>플로리다 말씀교회 <br />
          담임목사 김기석
        </h2>
        <div className="accordion">
        <div className="accordion-item">
            <button onClick={() => setShowSection1(!showSection1)}>
              15. 목회서신 {showSection1 ? '-' : '+'}
            </button>
            {showSection1 && <div className="content">
              <p>샬롬! <br/>
              성경은 예수 잘 믿으면 온갖 고난의 풍파에서 제외될 것이라고 가르치지 않습니다. 반대로 고난
              당하는 것을 이상하게 생각하지 말라고 가르치고 있습니다. 그래서 믿음 생활을 잘 하려고 하면
              할 수록 더 많은 고난과 마주합니다. 이유를 아십니까? 아담이 범죄한 순간부터 하나님은 선하신
              뜻을 이루시는 가장 중요한 방식으로 고난을 도구화하셨기 때문입니다. 그래서 하나님께서는
              어떤 사람의 일생을 통해 뜻을 이루시고자 하실 때는 그 사람이 반드시 깊고 어두운 고난의
              터널을 통과하게 하십니다. 인생의 밑바닥까지 내려가게 하십니다. 그 사람이 하나님께서
              예비하신 뜻을 이루도록 하나님께서 고난의 상황을 준비하셨기 때문입니다. 그러고보니 사람은
              고난의 상황을 통과하면서 하나님을 더 가까이 하게 됩니다. ‘하나님 앞에서 자신이 어떤
              존재인지?', ‘자신에게 고난의 상황을 허락하신 하나님의 뜻이 무엇인지?’를 비로서 발견합니다.
              대를 이을 아들이 없던 아브라함은 모든 것을 다 포기한 인생 후반에 비로서 아들을 주시겠다는
              하나님의 약속을 받았습니다. 하지만 아들 이삭을 얻기까지 아브라함은 25년을 기다려야
              했습니다. 그 기간이 아브라함에게는 긴 고난의 시간이었습니다. 하지만 고난의 긴 시간을
              겪으며 자신을 향한 하나님의 뜻을 발견하고 그 뜻을 따라 대를 이을 수 있는 아들까지 얻게
              되었습니다. 성도 여러분! 충분히 어두워야 밝은 달빛을 볼 수 있습니다. 고난은 분명 위장된
              축복입니다. 고난은 하나님께서 우리에게 예비된 복을 주시기 위한 전초단계입니다. 그렇다면
              삶의 여정에서 돌뿌리에 걸려 넘어지면 눈을 열어 주어질 복을 내다볼 수 있어야 하지
              않겠습니까? 이 믿음의 자세로 부닥치는 고난을 이겨나가시며 예비된 복을 누리시는 성도
              여러분이 되시길 주 이름으로 축원 드립니다. </p>
            </div>}
          </div>
        <div className="accordion-item">
            <button onClick={() => setShowSection2(!showSection2)}>
              14. 목회서신 {showSection2 ? '-' : '+'}
            </button>
            {showSection2 && <div className="content">
              <p>러시아의 작가 돌스토이는 ‘우리는 세상을 사는 것이 아니라 세상을 지나가고 있다’라며, 인생이
              나그네임을 말하였습니다. 그렇습니다. 우리는 세상을 사는 것이 아니라 속절없이 흐르기만 하는
              세상을 지나가고 있는 나그네입니다. 그래서 세월이란 말만 들으면 아쉬움이 진하게 묻어납니다.
              안타깝게도 흐르기만 하는 세월은 멈춤이 없습니다. 그래서 아침은 저녁이 되고 저녁은 새벽이
              되며 이런 날들이 되풀이 되어 1년이 되면서 우리를 인생의 종착역으로 몰아갑니다. 우리 모두는
              이렇게 흐르는 세월 속에 묻혀갈 뿐입니다. 빈수레가 굴러가듯이 결코 멈춤이 없이 굴러가기만
              하는 것이 세월입니다. 유수와 같이 어디론가 흘러가면서 훌쩍 사라져버리기도 하는 것이
              세월입니다. 때로는 가는 세월이 완행 열차처럼 너무 느리다고 생각할 때도 있습니다. 때로는
              급행 열차처럼 신속히 날아감을 느낄 때도 있습니다. 이런 시간의 흐름 속에 장미가 피고
              진달래가 피고 코스모스가 피듯이 세월의 흐름 속에 내 인생도 피어납니다. 하지만 시간의 흐름
              속에 꽃들이 시들어가듯이 내 인생도 언젠간 한세상 살고나면 흙으로 돌아갑니다. 세월이 내
              상황을 고려해 주지는 않습니다. 내 인생은 오늘도 세월의 돛단배를 타고 정처없이 흐르고 있을
              뿐입니다. 그렇다고 흐르기만 하는 세월이 야속하다고 탓하기만 해서는 안 됩니다. 남은 세월이
              짧다고 불평해서도 안 됩니다. 그 누구도 세월을 이기는 자, 세월을 역행하는 자가 없기
              때문입니다. 다만 창조자, 하나님만 기억해야할 뿐입니다. 시간을 창조하시고 세월의 흐름을
              주관하시는 하나님께서 저와 여러분 인생의 주인이십니다. 내일로 흘러가는 우리 인생이
              하나님만 주목하시므로 가시밭 같은 세상에서 백합화처럼 피어나는 성도들이 되셔야 할 줄
              믿습니다. 하나님께서 이런 우리의 삶을 앞장서 이끌어가실 줄 분명히 믿습니다. <br/>
              되시길 주 예수 그리스도 이름으로 축원 합니다. </p>
            </div>}
          </div>
        <div className="accordion-item">
            <button onClick={() => setShowSection3(!showSection3)}>
              13. 목회서신 {showSection3 ? '-' : '+'}
            </button>
            {showSection3 && <div className="content">
              <p>샬롬! <br/>              
              성경은 예수 잘 믿으면 온갖 고난의 풍파에서 제외될 것이라고 가르치지 않습니다. 반대로 고난
              당하는 것을 이상하게 생각하지 말라고 가르치고 있습니다. 그래서 믿음 생활을 잘 하려고 하면
              할 수록 더 많은 고난과 마주합니다. 이유를 아십니까? 아담이 범죄한 순간부터 하나님은 선하신
              뜻을 이루시는 가장 중요한 방식으로 고난을 도구화하셨기 때문입니다. 그래서 하나님께서는
              어떤 사람의 일생을 통해 뜻을 이루시고자 하실 때는 그 사람이 반드시 깊고 어두운 고난의
              터널을 통과하게 하십니다. 인생의 밑바닥까지 내려가게 하십니다. 그 사람이 하나님께서
              예비하신 뜻을 이루도록 하나님께서 고난의 상황을 준비하셨기 때문입니다. 그러고보니 사람은
              고난의 상황을 통과하면서 하나님을 더 가까이 하게 됩니다. ‘하나님 앞에서 자신이 어떤
              존재인지?’, ‘자신에게 고난의 상황을 허락하신 하나님의 뜻이 무엇인지?’를 비로서 발견합니다.
              대를 이을 아들이 없던 아브라함은 모든 것을 다 포기한 인생 후반에 비로서 아들을 주시겠다는
              하나님의 약속을 받았습니다. 하지만 아들 이삭을 얻기까지 아브라함은 25년을 기다려야
              했습니다. 그 기간이 아브라함에게는 긴 고난의 시간이었습니다. 하지만 고난의 긴 시간을
              겪으며 자신을 향한 하나님의 뜻을 발견하고 그 뜻을 따라 대를 이을 수 있는 아들까지 얻게
              되었습니다. 성도 여러분! 충분히 어두워야 밝은 달빛을 볼 수 있습니다. 고난은 분명 위장된
              축복입니다. 고난은 하나님께서 우리에게 예비된 복을 주시기 위한 전초단계입니다. 그렇다면
              삶의 여정에서 돌뿌리에 걸려 넘어지면 눈을 열어 주어질 복을 내다볼 수 있어야 하지
              않겠습니까? 이 믿음의 자세로 부닥치는 고난을 이겨나가시며 예비된 복을 누리시는 성도
              여러분이 되시길 주 이름으로 축원 드립니다. </p>
            </div>}
          </div>
          <div className="accordion-item">
            <button onClick={() => setShowSection4(!showSection4)}>
              12. 목회서신 {showSection4 ? '-' : '+'}
            </button>
            {showSection4 && <div className="content">
              <p>샬롬! <br/> 
                주 이름으로 문안드립니다. <br />
                성도 여러분! 고난이 왜 괴로울까요?  고난이 괴로운 이유는, 내가 고난을 당하는 까닭을 명료하게 알지 못하기 때문입니다. 심지어 나는 잘못이 없는데, 나에겐 뚜렷한 이유나 책임질 일도 없는데, 이런 상황에서 하나님께서 침묵하신다고 느낄 때면 정말 고통스럽기만 합니다. 나를 사랑하신다고 말씀하시는 하나님! 내가 사랑하는 하나님께서, 직면한 고통의 상황과 멀리 계신다고 느낄 때는 정말 고통스럽기만 합니다. 물론 하나님의 침묵에도 하나님의 뜻이 있음을 믿습니다. 하지만 실제 피를 토히고 뼈를 깍는 고통의 상황에서 하나님의 부재, 하나님의 침묵을 느낀다면 이것만큼 나를 힘들고 고통스럽게 하는 일은 없습니다. 더더군다나 하나님의 도우심을 간절히 구하여도 도무지 상황 변화의 조짐이 없을 때면, 정말 내 모든 삶을 아예 포기하고픈 생각이 굴뚝같이 들기도 합니다. 그럼에도 이런 상황에서 믿음의 자리를 지키며 내 할 일을 묵묵히 감당한다면 당장 상황의 반전을 통해 기대하는 축복은 없을지라도, 하나님을 향한 믿음이 차곡차곡 축적되고 쌓이며 결국 하나님의 선하신 뜻을 따라 하나님께 더 다가서게 될 줄 믿습니다. 그리고 내 모든 상황을 합력하여 선을 이루시는 하나님을 새롭게 만나는 복을 누리게 될 줄 믿습니다. 이 믿음의 자세로 고난의 상황을 바로 직시하시므로 요동하지 않으시는 성도들이 되시길 주 이름으로 축원합니다. 쟌 브래너집사님의 빠른 회복을 위해 계속 기도를 부탁드립니다. <br /> 
                김기석목사 드림 </p>
            </div>}
          </div>
          <div className="accordion-item">
            <button onClick={() => setShowSection5(!showSection5)}>
              11. 목회서신 {showSection5 ? '-' : '+'}
            </button>
            {showSection5 && <div className="content">
              <p>샬롬!성도 여러분! <br />
                주 이름으로 문안드립니다. 6월의 마지막 주간을 잘 보내고 계시지요? 그러고보니, '어떤 생각을 어떤 상황에서 어떻게 하는냐?' 하는 것이, 일상의 삶을 결정하는 중요한 요소인 것 같습니다. 그러므로 생각을 잘 해야 합니다. 사실 인생의 전 부분은 두 번 창조된다고 할 수 있습니다. 먼저는 우리의 마음 속에서 창조가 되고 두 번째는 삶 가운데 실제로 창조 된다고 할 수 있습니다. 따지고보면 오늘 내 모습은 어제 내 생각의 결과이지 않습니까? 물론 오늘 내가 하는 내 마음의 생각이 오늘과는 다른, 내일의 또 다른 나의 모습을 창조하게 될 것은 분명합니다. 힘겨운 상황에서도 요셉처럼 형통한 삶을 소망한다면 생각을 바르게 해야 합니다. 생각은 보이지 않고 만질 수 없지만, 그런 무형의 생각이 보이고 느껴지는 유형의 세계, 일상을 창조하기 때문입니다. 인생에 왜 문제가 많습니까? 인생이 왜 문제의 깊은 웅덩이로 빠집니까? 그것은 생각을 바르게 하지 않아서 그렇습니다. 그런데 삶을 창조하는 생각은 무한대, 즉 용량의 제한이 없기 때문에 우리는 하루에만도 무수히 많은 생각을 동시다발적으로 합니다. 그러니 정말 생각을 올바르게 해야 합니다. 생각을 잘 하려면 생각의 기준을 분명히 해야 하는데, 그 기준이 바로 '말씀'입니다. 말씀을 붙들고 삶의 기준과 좌표로 삼아야 할 분명한 이유입니다. 이제부터라도 말씀 중심의 올바른 생각으로 믿음 생활을 풍성하게 살찌워가시는 성도들이 되셔야 할 줄 믿습니다. 6월의 마지막 주말을 은혜 가운데 평안히 보내시고 주일에 반가이 뵙겠습니다. <br />
                김기석목사 드림  </p>
            </div>}
          </div>
          <div className="accordion-item">
            <button onClick={() => setShowSection6(!showSection6)}>
              10. 목회서신 {showSection6 ? '-' : '+'}
            </button>
            {showSection6 && <div className="content">
              <p>샬롬! <br/>
                성도 여러분! <br/>
                삶의 전반이 하나님의 은혜임을 입이 마르고 닳도록 말을 하면서도 우리는 어느 것에도 쉽게 만족할 줄 모르는 것 같습니다. 마치 은혜 불감증에 걸린 환자처럼요...! 사람의 이목을 집중시키는 크고 좋고 화려한 것에만 마음을 빼앗기고 있기 때문입니다. 눈에 잘 띄지 않는 작은 것과 적은 것으로부터 주어지는 행복을 놓치며 살기 때문입니다. 생각해보면 행복이란  결코 크고 많고 화려한 것으로부터 오는 것이 아님을 알 수 있습니다. 반대로 행복은 일상 속에서 발견되는 조그마한 아름다움과 사랑스러움과 감사함에 있습니다. 이른 아침에 따뜻하면서도 향기로운 차 한 잔을 마시면서도, 길을 걷다가 딱딱한 시멘트 바닥을 뚫고 올라와 기어이 꽃을 피운 이름 모를 꽃을 보면서도, 혼자 책을 읽거나 묵상을 하면서도, 땀에 흠뻑 젖도록 운동을 하고 샤워를 하면서도, 다정한 친구로부터 걸려오는 전화 한 통화나 메세지를 받으면서도, 받은 은혜를 찬찬히 계수하며 살포시 웃음을 지으면서도 행복을 느낍니다. 행복은 과연 일상적이고 사소한 곳에서 오는 것이지 결코 크고 많은 화려한 곳에서 오는 것은 아닌 줄 압니다. 성도 여러분! 행복하시길 소망하십니까? 정말 그렇게 되시길 소망하십니까? 그럼 작은 것, 소소한 것을 소중히 여기는 마음이 있어야 할 줄 믿습니다. 왜냐하면 예수님의 가르침은 작은 것을 소중히 여기는 마음에서 출발하기 때문입니다. 오늘 행복하지 않으시렵니까? 예수님의 가르침을 따라 삶 전반을 돌아보시므로 행복한 날을 보내시길 주 이름으로 축원합니다. <br />
                김기석목사 드림  </p>
            </div>}
          </div>
          <div className="accordion-item">
            <button onClick={() => setShowSection7(!showSection7)}>
              9. 목회서신 {showSection7 ? '-' : '+'}
            </button>
            {showSection7 && <div className="content">
              <p>샬롬! <br/>
                성도 여러분! 외로워지고 싶은 사람이 있을까요? 물론 그런 사람은 눈에 불을 켜고 봐도 없는 줄 압니다. 사람은 너나 할 것 없이 군중 속의 외로움을 느끼고 싶어하지 않기 때문입니다. 그 누구도 나에게 관심을 주거나 나와 함께하고자 하는 사람이 아무도 없다는 생각을 하기 싫어합니다. 외로워지고 싶은 사람은 물론이요 외로움을 당하고 싶은 사람은 아무도 없기 때문입니다. 하지만 외로움 때문에 눈물로 상한 마음을 달래며 사는 것이 현대인들의 모습입니다. 그런데 아십니까? 이런 우리에게 하나님은 분명히 말씀하셨답니다. '내가 너를 지명하여 불렀나니 너는 내 것이다. 너는 내 소유다.' 외로움 속에서도 우리가 강하고 담대해야 할 이유이지 않겠습니까? 그러고보니 때때로 외로움 때문에 글을 쓰고 외로움 때문에 주위를 더 돌아보는 것 같습니다. 외로움 때문에 말씀을 더 찾아 묵상하고 외로움 때문에 더 기도하며 하나님께 메달리는 것 같습니다. 오히려 외로움 때문에 삶에 열정을 더 불사르는 것 같기도 합니다. 어쩌면 외로움이 저와 여러분의 속사람을 깨우시고자 하나님께서 주시는 sign인지도 모르겠습니다. 어떤 외로움의 현장일지라도 나를 지명하여 붙드신 하나님만 바라시는 믿음으로 삶의 열정을 더 불태워가시는 성도들이 되시길 주 이름으로 축원합니다. 이번 주에 있을 성찬식을 위해 기도로 준비해 주시길 부탁드립니다. <br/>
                김기석목사 드림  </p>
            </div>}
          </div>
          <div className="accordion-item">
            <button onClick={() => setShowSection8(!showSection8)}>
              8. 목회서신 {showSection8 ? '-' : '+'}
            </button>
            {showSection8 && <div className="content">
              <p>샬롬, 성도 여러분! <br/>
                주 이름으로 문안드립니다. <br/>
                찬찬히 생각해보면 사람은 너나 할 것 없이 누구나 자신만의 아픔을 한 바구니씩 안고 살아갑니다. 가족을 먼저 떠나 보낸 아픔, 사랑하는 자를 잃은 아픔, 사업의 실패로 인한 아픔, 관계의 상실로 인한 아픔, 건강의 문제로 인한 아픔, 죄를 지은 이후에 따르는 아픔 등, 이루 말할 수 없는 아픔의 목록들이 아픔의 다양함을 대변해주고 있습니다. 구원 역사의 출발점이었던 아브라함도 사랑하는 아내 사라를 잃은 아픔이 있었습니다. 야곱도 그토록 아끼고 사랑하던 아들 요셉을 잃은 아픔이 있었습니다. 다윗도 범죄하여 당한 아픔이 있었습니다. 이처럼 모든 사람에게는 크고 작은 자신만의 아픔과 상처들이 있기 마련입니다. '나에게는 이런 아픔이 없다'는 사람이 있다면 그 사람이야말로 위선의 가면을 벗어야 할 사람입니다. 그런데 이런 아픔과 상처를 피할 수 없다면 차라리 이것들을 가슴에 품고 살아가는 믿음과 지혜가 있어야 하겠지요? 아픔이 삶을 구성하는 근간이기 때문입니다. 아픔은 죄가 아닙니다. 아픔이 죄가 아니고 아픔이 지금 내 인생의 끝자락도 아닙니다. 그럼 어떻게 하면 아픔을 내 삶에 품고 일어설 수 있겠습니까? 그것은 내 안에 있는 아픔, 내 안에 있는 상처 위에 높은 등대를 세우면 됩니다. 이렇게만 한다면 지금 맞닥뜨린 아픔이 남은 인생 여정 길에 분명한 이정표가 되어 줄 것이기 때문입니다. 그런데 저와 여러분을 위해 십자가에서 자신의 전부를 내어주신 우리 주님께서 등대이십니다. 그럼 주님 앞에 간절하면서도 겸손히 엎드러야 하지 않겠습니까? 이제 우리 인생을 비추시는 참 빛, 등대이신 주님 아래에 머무시므로 아픔을 인생의 이정표, 터닝포인트로 삼아내시므로 승리의 삶을 살아가시는 모든 성도들이 되시길 주 이름으로 축원합니다. <br/>
                주일에 반가이 뵙겠습니다. <br/>
                김기석목사 드림  </p>
            </div>}
          </div>
          <div className="accordion-item">
            <button onClick={() => setShowSection9(!showSection9)}>
              7. 목회서신 {showSection9 ? '-' : '+'}
            </button>
            {showSection9 && <div className="content">
              <p>샬롬! <br/>
              성도 여러분! 주 이름으로 문안드립니다. 한 주간을 어떻게 보내시고 계시나요? <br/>
              살다보면 누구나 할 것 없이 빈 마음, 빈 몸일 때가 있습니다. 그 누구도 나를 찾지 않고 내가 찾아갈 그 누구도 없는 때가 있습니다. 이럴 때면 쏟아지는 빗줄기를 혼자 맞는듯한 느낌 뿐이랍니다. 정말 이럴 때면 온 마음이 흠뻑 젖어 외로움만 더해지기도 합니다. 그렇습니다. 혼자면 춥기만 합니다. 집안이 아무리 따뜻해도, 아무리 두꺼운 이불과 외투를 덮어도, 마음이 시린 외로움은 십사리 가시질 않습니다. 그러나 바로 이런 순간이야말로 내 안에 나를 만날 때이지 않습니까? 깊은 외로움과 상실감에 홀로 절망을 하기도 하지만, 이런 순간이야말로 내 안에 참 자아를 만날 때이지 않습니까? 내가 나를 찾아 만날 때, 내 안에 계신 주께서 이런 나를 붙드시고 계심을 새삼 깨달아 알게 될 줄 믿습니다. 내가 혼자가 아님을 깨달아 알게 될 줄 믿습니다. 그러고보니 외로움 때문에 말씀의 바다에 풍덩 빠지고, 외로움 때문에 찬양의 고백을 하고, 외로움 때문에 더 엎드려 기도하고, 외로움 때문에 믿음의 지체를 돌아보게 되는 것 같습니다. 외로움 때문에 깨닫는 것들이 참 많은 것 같습니다. 어쩌면 외로움이, 잠자는 내 영혼을 깨우시고자 하나님께서 위로부터 내리시는 따뜻한 채찍이라는 생각이 들기도 합니다. 외로움이 나를 향한 하나님의 사랑의 증표라는 믿음으로 혼자됨을 이겨나가시는 성도들이 되시길 주 이름으로 축원합니다. <br/>
              덧붙여 한 가지 안타까운 소식을 전합니다. 이영미집사님의 시어머니께서 소천하셨습니다. 집사님을 포함한 모든 유가족들에게 하나님의 위로하심이 함께 하시길 기도부탁드립니다. 장례 일정은 주일에 알려드리겠습니다. <br/>
              김기석목사 드림  </p>
            </div>}
          </div>
          <div className="accordion-item">
            <button onClick={() => setShowSection10(!showSection10)}>
              6. 목회서신 {showSection10 ? '-' : '+'}
            </button>
            {showSection10 && <div className="content">
              <p>샬롬! <br/>
              성도 여러분! 인생에서 겪는 가장 큰 상실과 아픔이 있다면 무엇이겠습니까? 물론 사람마다 겪는 상실과 아픔의 종류와 무게는 다 다를것입니다. 하지만 다 다를지라도 역시 죽음에 따른 상실과 아픔만큼 우리를 힘들게 하는 일은 없는 줄 압니다. 내 분신과도 같은 사랑하던 사람을 더이상 이 세상에서는 마주할 수 없다는 현실이 삶을 가장 병들게 하는 큰 상실이자 아픔인 줄 압니다. 그렇다고 삶을 내팽개칠 수는 없겠지요? 그럼 어떻게 해야 하겠습니까? 병든 인생을 극복하기 위해서 해야 할 최선의 일이 있다면 그것은 바로 슬픔의 시간을 갖는 일인 줄 압니다. 아플 때 마음껏 아파하고 슬플 때 마음껏 슬퍼하는 일이야말로 병든 삶이라지만, 살아있는 삶을 회복시키는 가장 지혜로운 방법이기 때문입니다. 지극정성을 다해 모시던 시아버님을 떠나 보내신 이영미집사님의 상실과 아픔을 우리가 무엇으로, 어떻게 위로할 수 있겠습니까? 다만 같은 믿음의 지체로서 집사님의 아픔과 슬픔을 내 아픔과 슬픔으로 알고 하나님의 위로하심을 구하는 모습이 우리가 할 수 있는 최선의 일인 줄 압니다. 아픔을 믿음으로 잘 극복하시고 일상으로 속히 복귀하시도록 집사님과 유가족들을 위해 기도해주시길 부탁드립니다. 집사님과 유가족은 물론 우리 모두에게 위로하시는 하나님의 은혜가 임할 줄 믿습니다. 7월의 첫 주말을 은혜 가운데 평안히 보내시고 7월의 첫 주일에 반가이 뵙겠습니다. <br/>
              김기석목사 드림 </p>
            </div>}
          </div>
          <div className="accordion-item">
            <button onClick={() => setShowSection11(!showSection11)}>
              5. 목회서신 {showSection11 ? '-' : '+'}
            </button>
            {showSection11 && <div className="content">
              <p>샬롬! <br/>
                성도 여러분! 인생이란, 하얀 백지 위에 하루하루 색종이로 모자이크를 붙여가는 것과 같습니다. 그런데 하얀 백지에다가 각양각색의 모자이크를 붙여가는 예술가외에는 그 모자이크가 어떤 종류의 완성품이 될런지 아무도 알 수 없습니다. 또한 인생이란, 점 하나 없는 하얀 백지 위에 크레용으로 빈 여백을 그려가는 것과 같습니다. 그런데 알록달록한 크레용으로 그림을 그려가는 예술가외에는 그 그림이 어떤 그림이 될런지 아무도 알 수 없습니다. 마찬가지로 내 인생의 예술가이신 하나님께서 나를 통해 이루어가시는 하나님의 의도와 구상을 내가 당장에 알 길이 없습니다. 어찌 지음을 받은 토기가 토기장이의 마음을 알 수 있겠습니까? 하지만 주어진 매일의 일상 가운데 나만의 모자이크를 묵묵히 붙여가노라면, 주어진 삶의 현장에 열정을 다해 나만의 그림을 그려나간다면, 언젠간 불현듯 나를 통해 이루시길 원하시는 하나님의 긍극적인 뜻이 내 눈에 들어오게 될 것입니다. 꿈이 요행으로 이루어지지 않듯이 나를 향한 하나님의 뜻 또한 요행으로 이루어지지 않습니다. 요행을 바라는 것은 망상일 뿐입니다. 하지만 오늘의 삶의 현장에서 실패와 좌절의 쓴 잔을 마시고, 설령 쓰러져도 툴툴 털고 일어나 다시 모자이크를 붙이고, 다시 그림을 그려나가는 열정이 있다면, 반드시 나를 향한 하나님의 선하신 뜻이 이루어짐을 경험케 될 줄 믿습니다. 물론 하나님의 선하신 뜻이 이루어지는 순간이 궁극적으로 나에게 신령한 만나와 메추라기가 주어지는 은혜의 때가 될 줄 믿습니다. 열정을 쏟아내는 열심으로 삶의 현장을 하나님의 뜻을 이루어내는 은혜의 장으로 삼아내시는 성도들이 되시길 주 이름으로 축원합니다. <br/>
                김기석목사 드림  
                </p>
            </div>}
          </div>
          <div className="accordion-item">
            <button onClick={() => setShowSection12(!showSection12)}>
              4. 목회서신 {showSection12 ? '-' : '+'}
            </button>
            {showSection12 && <div className="content">
              <p>샬롬! <br/>
                성도 여러분! <br/>
                내가 나를 비우고 나를 내려놓는 일이 쉬운 일이 아닙니다. 내가 나를 던져버리는 일이 결코 쉬운 일이 아닙니다. 하지만 내가 나를 잊어버리지 않고서는 내 안에 하나님을 모셔들일 수 없습니다. 내가 있는 곳이 지옥이요 내가 없는 곳에 내 대신 하나님께서 계시게 됩니다. 모세가 호렙산에 올랐을 때 하나님께서 모세에게 '때묻은 너의 신발을 벗어라!'고 하셨습니다. 양을 치던 그의 지팡이도 던져버리라고 하셨습니다. 하나님은 모세에게 모든 것을 다 내려놓게 하셨습니다. 여호수아와 갈렙도 자신을 겸손히 내려놓았을 때 가나안 땅을 밟을 수 있었습니다. 병든 내 육신이 치유되길 정말 소망하십니까? 틀어진 관계가 회복되길 정말 소망하십니까? 갈급한 영혼이 해갈 받기를 정말 소망하십니까? 위로부터 내리시는 참된 평안과 안식을 누리시길 정말 소망하십니까? 절박한 심정으로 이렇게 소망하신다면 하나님께 내 모든 것을 다 내려놓으십시오! 하나님께 다 던져버리십시오! 하나님 앞에서 벌거벗으십시오! 하나님 앞에서 오늘의 나를 완전히 죽일 때 내일의 내가 새롭게 태어날 것이기 때문입니다. 그러고보니 믿음의 여정이란 내 안에 나를 계속 죽여가는 과정의 연속이라는 생각이 듭니다. 나를 중단없이 죽여가시므로 날마다 하나님께 다가가시는 복된 성도들이 되시길 주 이름으로 축원합니다. 8월의 첫 주말을 은혜 가운데 평안히 보내시고 주일에 반가이 뵙겠습니다. <br/>
                김기석목사 드림  </p>
            </div>}
          </div>
          <div className="accordion-item">
            <button onClick={() => setShowSection13(!showSection13)}>
              3. 목회서신 {showSection13 ? '-' : '+'}
            </button>
            {showSection13 && <div className="content">
              <p>샬롬! <br/>
              성도 여러분! <br/>
              인생은 문제투성이입니다. 크고 작은 다양한 문제거리들로 구성된 것이 인생입니다. 안타깝지만 최선을 다하는 삶을 살아도 문제로부터 자유로울 수 없습니다. 때로는 문제를 해결하고, 때로는 문제 앞에서 괜찮은 척, 아무 일 없다는듯이 외면해도, 늘 삶을 따라다니는 것이 문제입니다. 그래서 때때로 어디론가 훌쩍 도망치고 싶은 생각이 굴뚝처럼 들기도 합니다. 심지어 어떤 사람은 직면한 문제 때문에 극단적인 생각을 하기도 합니다. 하지만 이런 문제들 앞에 한번쯤 생각해 볼 것이 있습니다. 그것은 바로 '이토록 문제가 많은 나 자신이 정말 문제인 것은 아닐까?'하는 생각입니다. 왜냐하면 어떤 문제거리들 가운데서도 나와 함께 하시는 주님을 놓치고 있기 때문에 문제가 또다른 문제를 낳도록 방치할 때가 많기 때문입니다. 세찬 풍랑이 몰아치는 배를 타고 있던 예수님의 제자들은 두려움이라는 문제 앞에 사시나무 떨듯이 떨기만 하였습니다. 이유가 무엇입니까? 배에 함께 계시던 주님을 보지 않았기 때문입니다. 성도 여러분! 문제 앞에서, '왜 나를 돌봐주시지 않으십니까?' 라고 항변하기 전에, 문제투성이 가운데 나와 늘 함께 하시는 주님을 보시십시오! 지금의 문제가 하나님과 한 걸음 더 가까와지는 동력이 됨을 체험케 되실 줄 믿습니다. 인자하신 주님 한 분만 바라보시므로 각종 문제거리들을 믿음의 동력으로 삼아내시는 모든 성도들이 되시길 주 이름으로 축원합니다. <br/>
              김기석목사 드림  </p>
            </div>}
          </div>
          <div className="accordion-item">
            <button onClick={() => setShowSection14(!showSection14)}>
              2. 목회서신 {showSection14 ? '-' : '+'}
            </button>
            {showSection14 && <div className="content">
              <p>샬롬! <br/>
                벌써 한 주간을 마감하는 상큼한 금요일 아침입니다. 성도 여러분! 지난 한 주간 그리스도인다운 삶을 사셨나요? 자문자답해 보시길 바랍니다. 봄은 파릇파릇해서 좋습니다. 여름은 더워서 좋습니다. 가을은 넉넉해서 좋습니다. 그런데 겨울은 추워서 좋습니다. 봄은 생명이 분출하므로 파릇파릇해야 합니다. 여름은 작열하는  햇빛을 받아 솥뚜껑처럼 뜨거워야 합니다. 가을은 풍성한 결실 때문에 넉넉해야 합니다. 겨울은 뼛속까지 시리게하는 추위 때문에 추워야 합니다. 그래야만 가을에 곡식과 과실이 튼실하게 여물고 봄에는 새싹이 야물딱지게 돋아납니다. 그렇다면 우리는 그리스도인 다워야하지 않겠습니까? '사람이면 다 사람이냐? 사람다워야 사람이지!'라는 말이 있습니다. 사람은 사람다운 가치를 추구해야 사람이라는 뜻인 줄 압니다. 우리는 사람은 사람이되 보통 사람이 아닌 그리스도인입니다. 그리스도인으로 산다는 것은 그리스도 예수의 사람으로서 그에 합당한 삶을 사는 것입니다. 우리가 서있는 삶의 현장에서 그리스도인답게 생각을 하며 악한 세상의 풍조를 따르지 않고 하나님의 뜻을 따라 사는 것이 그리스도인답게 사는 일입니다. 오늘 우리는 그리스도인다운 삶을 살고 있습니까? 그리스도 예수님을 늘 앞세우시므로 삶의 전 영역에서 그리스도를 드러내는 그리스도인,  그리스도 예수님의 향기를 발산해내는 그리스도인으로 살아가시는 성도들이 되셔야 할 줄 믿습니다. 다시 말씀을 드립니다. 주일 예배는 10시 50분부터 찬양으로 시작합니다. 그 전에 미리 나오셔서 기도와 찬양으로 예배에 임하실 때 드리는 예배가 거룩한 산 제가 되며 은혜가 가득한 시간이 될 줄 믿습니다. 주일에 반가이 뵙겠습니다. <br/>
                김기석목사 드림  </p>
            </div>}
          </div>
          <div className="accordion-item">
            <button onClick={() => setShowSection15(!showSection15)}>
              1. 목회서신 {showSection15 ? '-' : '+'}
            </button>
            {showSection15 && <div className="content">
              <p>안타깝지만 어떤 삶을 살아도 문제는 항상 우리를 따라 다닙니다. 바늘 가는데 실이 가듯이 문제가 늘 따라다닙니다. 때로는 해결하고 때로는 무시해도 늘 곁에 머무는 것이 문제입니다. 
                때로는 모든 것을 다 때려치고 싶은 생각이 듭니다. 때로는 도망치고 싶은 생각이 듭니다. 때로는 죽고 싶은 생각마저 듭니다. 그러고보니 인생은 크고 작은 다양한 문제거리들로 구성이 되었음을 알게 됩니다. 그렇다고 우리가 당면하는 문제거리들을 다 이해하지는 못합니다. 문제거리들로 구성이 된 우리가, 문제투성이의 조각들로 구성이 된 우리가, 어찌 모든 문제를 바로 직시하고 풀어낼 수가 있을까요? 문제가 이해 되지 않을 때에는, 풀리지 않을 때에는 하나님께 맡기고 그냥 넘어가면 어떨까요? 야곱은 형 에서에 대한 두려움의 문제만 해결이 되면 모든 문제가 풀릴 줄 알았습니다. 그런데 산더미 같은 문제가 풀리자 이제 자신의 아들들이 살인을 저질러 가문이 위기에 처하는 더 큰 문제와 마주하게 되었습니다. 인생은 과연 끝없는 문제의 연속입니다. 지금까지 내 삶을 가로막고 있는 문제가 풀렸다고 해서 내 인생의 모든 문제가 사라진 것은 아닙니다. 하지만 하나님은 그런 야곱의 인생에 또다시 피할 길을 내시고 그를 통해 구속의 역사를 진행해 나가셨습니다. 문제투성이 인생에게 문제는 끝이 없기에 문제보다 더 큰 은혜를 준비하고 우리를 기다리시는 하나님을 끝까지 믿는 일이 중요할 뿐입니다. 이 일이 결국 문제를 풀어내는 방정식입니다. 우리 인생은 내 소망과 계획대로 흘러가지 않습니다. 우리 인생은 하나님의 뜻을 따라 물 흐르듯이 흘러갑니다. 인생의 주인이 하나님이시기 때문입니다. 우리를 향한 하나님의 분명한 뜻이 있음을 믿는 믿음으로 문제거리들을 하나 둘 걸러내므로 하나님의 사람으로 자라나는 성도들이 되셔야 할 줄 믿습니다. </p>
            </div>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MissionsPage;
